import noUiSlider from 'nouislider'
import wNumb from 'wnumb'

const $sort = $('#filter-sort');
const $fakeSortButtons = $('.js-fake-sort-buttons');
const $fakeSort = $('select#fake-sort');

let $rangeSlider;

let latestAggregations = null;

Listing.customCallbacks.beforeFetch = () => {
    rEvent.dispatch('Listing.customBeforeFetch');
}

function updateFilterBubbles() {
    const withoutFilterBubbles = $('.js-filter-bubbles-item').length < 1;

    if (withoutFilterBubbles) {
        $('.js-filter-bubbles-reset').remove();
    }

    $('.js-filter-bubbles').toggleClass('is-empty', withoutFilterBubbles);
    $('.js-filter-submit-holder').toggleClass('without-bubbles', withoutFilterBubbles);
}

function renderFilterBubbles() {
    updateFilterBubbles();

    rEvent.on('FilterBubbles.afterRefresh', function () {
        updateFilterBubbles();
    });

    $('body').on('change', '.filter__form [type="checkbox"]', function () {
        updateFilterBubbles();
    });

    // filter bubbles reset hide
    $('body').on('click', '.js-filter-bubbles-item', function () {
        requestAnimationFrame(() => {
            updateFilterBubbles();
        });
    });

    $('body').on('click', '.js-filter-bubbles-reset', function () {
        $('.filter__form').find('[type="reset"]').click();
        updateFilterBubbles();
    });
}

const renderMultiselect = () => {
    $('#filter .c-form__item--select select').not('.is-loaded').each(function () {
        const $select = $(this);
        let options = {
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span><i class="ico ico-triangle-down is-on-right"></i></button>',
            },
            buttonClass: 'c-btn has-icon',
            enableHTML: true
        };

        if ($select.closest('#filter').length) {
            const moreText = $select.data('more-text')
            const lessText = $select.data('less-text')

            options.templates.ul = `
                <r-more-items r-more-items-self-target class="multiselect-container dropdown-menu" data-more-text="${moreText}" data-less-text="${lessText}">
                    <button type="button" class="c-link c-link--secondary is-more has-icon" r-more-items-trigger>
                        <span r-more-items-trigger-text>${moreText}</span>
                        <i class="ico ico-caret-down is-on-right"></i>
                    </button>
                </r-more-items>
            `;
            options.templates.filter = `
                <div class="multiselect-item multiselect-filter">
                    <div class="c-form__item c-form__item--text">
                        <input class="c-form__input multiselect-search" type="text">
                        <i class="ico ico-search"></i>
                    </div>
                </div>
            `;
            options.filterPlaceholder = $select.data('filter-text');
            options.enableCaseInsensitiveFiltering = true;
            options.onFiltering = (input) => {
                const $input = $(input);
                const $dropdownMenu = $input.closest('.dropdown-menu')

                if ($input.val()) {
                    $dropdownMenu.addClass('is-filtering');
                }
                if (!$input.val()) {
                    $dropdownMenu.removeClass('is-filtering');

                    $dropdownMenu.find('li').each(function() {
                        $(this).css('display', '');
                    });
                }
            };

            options.lazyBuildThreshold = 5;
            options.lazyBuildPriority = (element) => element.selected;
            options.lazyBuildDeprioritize = (element) => getOptionCount(element) === 0;
            options.onLazyBuild = ($lazySelect) => {
                decorateMultiselectItems($lazySelect);
            };
        }

        $select.multiselect(options);
        $select.addClass('is-loaded');

        if ($select.closest('#filter').length) {
            const $container = $select.next();
            const buildAll = () => $select.multiselect('buildRemainingOptions');

            $container.find('[r-more-items-trigger]').on('click', buildAll);
            $container.find('.multiselect-search').on('focus', buildAll);
        }
    });

    requestAnimationFrame(() => {
        $('#filter').find('select[type="multiselect"]').each(function () {
            decorateMultiselectItems($(this));
        });

        updateFilterBoxVisibility();
    })
}

const getOptionCount = (option) => {
    const raw = $(option).attr('data-count');

    if (!raw) {
        return null;
    }

    const parsed = parseInt(raw.replace(/<[^>]*>?/gm, '').replace(/[()]/g, ''), 10);

    return Number.isNaN(parsed) ? null : parsed;
}

const getOptionFieldValue = (option) => {
    const $option = $(option);
    const rawValue = $option.val();

    if ($option.attr('data-property-id')) {
        return $option.attr('data-property-id') + ';' + rawValue.replace("'", "\\'");
    }

    return rawValue;
}

const getAggregationCount = ($select, option) => {
    const type = $select.data('type');
    const value = String(option.value);
    let groupId = $(option).attr('data-property-id');
    let key = value;

    if (!groupId && (type === 'properties' || type === 'variations')) {
        groupId = value.substring(0, value.indexOf(';'));
        key = value.substring(value.indexOf(';') + 1);
    }

    const typeAggregations = latestAggregations[type] || {};
    const counts = groupId ? (typeAggregations[groupId] || {}) : typeAggregations;

    return parseInt(counts[key], 10) || 0;
}

const getCurrentCount = ($select, option) => {
    const pageLoadCount = getOptionCount(option);

    if (pageLoadCount === null || !latestAggregations) {
        return pageLoadCount;
    }

    return getAggregationCount($select, option);
}

const isAvailable = (count) => count === null || count > 0;

const getBuiltValues = ($select) => new Set(
    $select.next().find('.dropdown-menu li input').map((index, input) => input.value).get()
);

const decorateMultiselectItems = ($select) => {
    const $dropdownMenu = $select.next().find('.dropdown-menu'),
        type = $select.data('type'),
        inputsByValue = {};

    $dropdownMenu.find('li input').each(function () {
        inputsByValue[this.value] = this;
    });

    let availableCount = 0;

    $select.find('option').each(function () {
        const count = getCurrentCount($select, this),
            countHtml = $(this).attr('data-count'),
            input = inputsByValue[this.value];

        if (isAvailable(count)) {
            availableCount++;
        }

        if (!input || !countHtml) {
            return;
        }

        const $label = $(input).parent();

        if ($label.find('.is-count').length) {
            return;
        }

        $label.append(countHtml);

        if (count !== null) {
            $label.find('[data-element="filterItemAggregation"]').html(count);
        }

        const $link = $(input).parents('a')
            .attr('data-element', 'filterItem')
            .attr('data-type', type)
            .attr('data-field-value', getOptionFieldValue(this))
            .attr('data-count', count ?? '');

        if ($(this).data('link')) {
            $link.attr('href', $(this).data('link'));
        }
    });

    $dropdownMenu.toggleClass('hide-items', availableCount > 5);

    $dropdownMenu.find('li').filter(function () {
        return $(this).find('[data-element="filterItem"]').attr('data-count') != 0;
    }).each(function (key) {
        $(this).toggleClass('is-hidden', key > 4);
    });
}

const buildFirstAvailableOptions = ($select) => {
    if (!$select.data('multiselect')) {
        return;
    }

    const builtValues = getBuiltValues($select);
    const missing = $select.find('option').toArray()
        .filter((option) => isAvailable(getCurrentCount($select, option)))
        .slice(0, 5)
        .filter((option) => !builtValues.has(option.value));

    if (missing.length) {
        $select.multiselect('buildRemainingOptions', (element) => missing.includes(element));
    }
}

const updateFilterBoxVisibility = () => {
    $('#filter').find('select[type="multiselect"]').each(function () {
        const $select = $(this);

        const hasAvailableOptions = $select.find('option').toArray().some(function (option) {
            return isAvailable(getCurrentCount($select, option));
        });

        $select.closest('.catalog-filter__box').toggle(hasAvailableOptions);
    });
}

function updateRangeCallback(selectors, values, sliderInstance) {
    const $from = $(selectors.from),
        $to = $(selectors.to),
        fromVal = $from.val(),
        toVal = $to.val(),
        minValue = sliderInstance.options.range.min[0],
        maxValue = sliderInstance.options.range.max[0];

    if (minValue == values[0] && maxValue == values[1]) {
        // $from.val('').removeAttr('value');
        // $to.val('').removeAttr('value');

        // Filter.submit();

        // return true;
    }

    $from.val(Number(values[0]));
    $to.val(Number(values[1]));

    /*if (!fromVal && !toVal) {
        $to.trigger('change');
    }
    else if (fromVal === values[0]) {
        $to.trigger('change');
    }
    else if (toVal === values[1]) {
        $from.trigger('change');
    }*/
    Filter.submit();
}

function createPriceRange() {
    const $elem = $('.js-range-price'),
        $slider = $elem.find('.range-slider__slider'),
        maxValue = Number($elem.attr('data-max')),
        minValue = Number($elem.attr('data-min')),
        fromValue = Number($elem.attr('data-from')),
        toValue = Number($elem.attr('data-to')),
        currencySymbol = Eshop.options.currency.symbol_right;

    if (!$slider.length) {
        return false;
    }

    $rangeSlider = noUiSlider.create($slider[0], {
        start: [fromValue, toValue],
        range: {
            'min': [minValue],
            'max': [maxValue]
        },
        margin: 1,
        connect: true,
        tooltips: [
            wNumb({
                decimals: 0,
                suffix: ` ${currencySymbol}`
            }),
            wNumb({
                decimals: 0,
                suffix: ` ${currencySymbol}`
            })
        ],
        step: 1
    });

    $rangeSlider.on('change', function (values, handle) {
        updateRangeCallback({
            from: '[name="filter[price][from]"]',
            to: '[name="filter[price][to]"]'
        }, values, this);

        $('.js-filter-price-range:checked').prop('checked', false);
    });

    $('#filter-price-from, #filter-price-to').on('keydown', function (event) {
        if (event.which == 13 || event.keyCode == 13) {
            event.preventDefault();

            $(this).blur();
            $(this).trigger('change');
        }
    });

    $('#filter-price-from').on('change', function (event) {
        event.preventDefault();

        const min = Number($(this).attr('min')),
            inputToValue = Number($('#filter-price-to').val());

        let value = Number($(this).val()),
            setInput = false;

        if (value < min) {
            value = min;
            setInput = true;
        }
        else if (value > inputToValue) {
            value = inputToValue;
            setInput = true;
        }

        if (setInput) {
            $(this).val(value);
        }

        $rangeSlider.set([value, null]);
    });

    $('#filter-price-to').on('change', function (event) {
        event.preventDefault();

        const max = Number($(this).attr('max')),
            inputFromValue = Number($('#filter-price-from').val());

        let value = Number($(this).val()),
            setInput = false;

        if (value > max) {
            value = max;
            setInput = true;
        }
        else if (value < inputFromValue) {
            value = inputFromValue;
            setInput = true;
        }

        if (setInput) {
            $(this).val(value);
        }

        $rangeSlider.set([null, value]);
    });
}

const changeFakeSortButton = (value) => {
    $fakeSortButtons.find('.c-btn').removeClass('is-active');
    $fakeSortButtons.find(`.c-btn[data-value="${value}"]`).addClass('is-active');
}

const updateTitle = (data) => {
    const $titleElemHolder = $('.js-catalog-title');

    if (!$titleElemHolder.length) {
        return
    }

    const $titleElem = $titleElemHolder.find('h1');
    const baseName = $titleElemHolder.attr('data-name');
    let name = baseName;

    if (data.entity && data.entity.heading) {
        name = data.entity.heading;
    } else if (data.filtered_parameters) {
        name = baseName + " " + Object.values(data.filtered_parameters).join(" ");
    }

    if (!name) {
        return;
    }

    $titleElem.html(name);

    var title = document.title.split(" | ");

    document.title = name + " | " + title[1];
}

rEvent.on('Listing.customBeforeFetch', function() {
    if ($('.listing__holder').length) {
        $('.listing__holder').addClass('is-loading');
    }
    if ($('.c-msg.is-empty.listing').length) {
        $('.c-msg.is-empty.listing').addClass('is-loading');
    }
});

rEvent.on('Listing.fetchedData', function (data) {
    updateTitle(data);

    requestAnimationFrame(() => {
        if ($('.listing__holder').length) {
            $('.listing__holder').removeClass('is-loading');
        }

        if ($('.pager__load').length) {
            $('.pager__load').removeClass('is-loading');
        }
    })

    const $listingCount = $('.js-listing-count');

    if ($listingCount.length) {
        $listingCount.each(function () {
            const $countElem = $(this);
            let countHtml = data.count;

            if ($countElem.hasAttr('data-plural')) {
                const listingPlural = $countElem.data('plural');

                countHtml = data.count + ' ' + Format.plural(listingPlural[0], listingPlural[1], listingPlural[2], data.count);
            }

            if ($countElem.hasAttr('data-template')) {
                countHtml = $countElem.data('template').replace(':value:', countHtml);
            }

            $countElem.html(countHtml)
        });
    }
});

FilterBubbles.create = function(filterSelector, options) {
    this.template = options.template;
    this.clearFilterTemplate = options.clearFilterTemplate;

    this.initialize();

    rEvent.dispatch('FilterBubbles.created');

    return this;
}

FilterBubbles.add = function(data) {
    if (!data.content) {
        return;
    }

    if ($(this.container).find('.js-filter-bubbles-reset').length == 0) {
        $(this.container).prepend( _.template(this.clearFilterTemplate)({
            _class: ''
        }) );
    }

    $(this.container).append( _.template(this.template)(data));
    $('[data-element="filterBubbles"]').attr('data-count', $(this.holder).size());

    rEvent.dispatch('FilterBubbles.added');
}

Filter.submit = function () {
    rEvent.dispatch("Filter.beforeSubmit");

    for (const sliderEl of this.element.querySelectorAll('.js-filter-slider-holder')) {
        const inputs = sliderEl.querySelectorAll('input')
        let isBoundary = true

        boundaryCheck:
        for (const input of inputs) {
            for (const attribute of ['min', 'max']) {
                if (input.hasAttribute(attribute) && parseFloat(input.getAttribute(attribute)) != parseFloat(input.value)) {
                    isBoundary = false;

                    break boundaryCheck;
                }
            }
        }

        if (isBoundary) {
            for (const input of inputs) {
                input.value = ''
            }
        }
    }

    Listing.sendData(this.element, (response) => {
        this.submitCallback(response)
    });

    return false;
}

rEvent.on('Filter.submited', function (data) {
    latestAggregations = data.aggregations || {};

    $('#filter').find('select[type="multiselect"]').each(function () {
        const $select = $(this);

        buildFirstAvailableOptions($select);
        decorateMultiselectItems($select);
    });

    updateFilterBoxVisibility();
});

$(function () {
    renderMultiselect();
    renderFilterBubbles();

    if ($('.filter-price').length > 0) {
        createPriceRange();
    }

    // fake sort
    const sortValue = $sort.val();
    $fakeSort.val(sortValue);
    changeFakeSortButton(sortValue);

    $fakeSort.on('change', function () {
        const value = $(this).val();

        $sort.val(value).trigger('change');
    });

    $fakeSortButtons.on('click', '.c-btn', function() {
        const value = $(this).data('value');

        changeFakeSortButton(value);
        $sort.val(value).trigger('change');
    });

    // filter reset
    rEvent.on("Filter.reset", function () {
        const $inputFrom = $('#filter-price-from'),
            fromValue = Number($inputFrom.attr('min')),
            $inputTo = $('#filter-price-to'),
            toValue = Number($inputTo.attr('max'));

        $inputFrom.val(fromValue);
        $inputTo.val(toValue);

        if ($rangeSlider) {
            $rangeSlider.set([fromValue, toValue]);
        }

        $('.js-filter-price-range:checked').prop('checked', false);

        // age sliders reset
        $('.js-filter-age-slider-elem').each(function () {
            $('.js-filter-age-from').removeAttr('value');
            $(this).parents('.js-filter-age-slider-holder').find('.js-filter-age-fake-from').val('');
            this.noUiSlider.set([0, null]);

            Filter.submit();
        });
    });

    $('.js-filter-price-range').on('change', function () {
        const $checkedInput = $('.js-filter-price-range:checked'),
            priceArray = $checkedInput.val().split(';'),
            actualMin = parseFloat(priceArray[0]),
            actualMax = parseFloat(priceArray[1]);

        let min = 99999,
            max = 0;

        if (actualMin < min) {
            min = actualMin;
        }

        if (actualMax > max) {
            max = actualMax;
        }

        $('#filter-price-from').val(min);
        $('#filter-price-to').val(max);

        $rangeSlider.set([min, max]);

        Filter.submit();
    });

    $(document).on('click', '.pager__list a', function(event) {
        event.preventDefault();

        $.get($(this).attr('href'), {}, function(data) {
            Listing.callbacks.update(data);
        }, 'json');

        $(this).addClass('is-loading');

        if ($('.listing__holder').length) {
            $('.listing__holder').addClass('is-loading');
        }
    });

    $(document).on('click', '.pager__load', function(event) {
        $(this).addClass('is-loading');
    });

    $('.js-tips-video-trigger').on('click', function() {
        $(this).closest('.js-lightbox-holder').find('.js-lightbox').first().trigger('click');
    });

    // TODO: nejaky chat na lubici, mozno sa da pouzit na footer chat
    //
    // const chatTrigger = document.querySelector('.js-trigger-chat');

    // if (chatTrigger) {
    //     chatTrigger.addEventListener('click', function (event) {
    //         const iframeChat = document.getElementById('chat-application-iframe');

    //         event.preventDefault();

    //         if (iframeChat) {
    //             iframeChat.contentWindow.document.querySelector('.MuiButtonBase-root').click()
    //         }
    //     });
    // }

    /*
    $('.js-trigger-description-hide').on('click', function() {
        $(this).closest('r-shorten').find('.js-trigger-description').trigger('click');
    });
    */

    $('.js-full-description-toggle').on('click', function() {
        const toggleEl = this;
        const toggleTextEl = toggleEl.querySelector('.js-toggle-text');
        const headerDescriptionEl = document.querySelector('.js-full-description-header');
        const descriptionHolderEl = document.querySelector('.js-full-description-holder');
        const descriptionEl = document.querySelector('.js-full-description-content');

        if (toggleEl.classList.contains('is-active')) {
            toggleEl.classList.remove('is-active');
            descriptionHolderEl.classList.remove('hide');
            toggleTextEl.innerHTML = toggleEl.getAttribute('data-show-more-text');
            headerDescriptionEl.innerHTML = '';
        } else {
            toggleEl.classList.add('is-active');
            descriptionHolderEl.classList.add('hide');
            toggleTextEl.innerHTML = toggleEl.getAttribute('data-show-less-text');
            headerDescriptionEl.innerHTML = descriptionEl.innerHTML;
        }
    });

    $('.js-seo-link').addClass('hidden');
});
